//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import '@arcgis/map-components/components/arcgis-compass';
import { ArcgisCompass } from "@arcgis/map-components-react";

/**
 * コンパスボタン (ツールチップ編集版)
 */
export default function MapCompassButton(props) {
  return (
    <ArcgisCompass
      {...props}
      messageOverrides={{
        reset: '右ボタンのドラッグで地図を回転できます。'
            + '\nこのボタンは回転の方向をリセットします。',
      }}
    />
  );
}
